import axios from '../lib/axios'
import Bugsnag from './Bugsnag'
import AuthenticationService from '../services/AuthenticationService'
import Store from '../store/Store'

const url = process.env.ZLICK_V2

export default {
  search: ({ searchQuery, page, limit }) => {
    if (!AuthenticationService.isInRole(['admin', 'support', 'analyst'])) throw new Error('Permission denied. Cannot search transactions')
    return axios.get(url + '/subscriptions/findByQuery', {
      params: {
        search: searchQuery ? searchQuery.searchValue : undefined,
        startDate: searchQuery ? searchQuery.dates.startDate : undefined,
        endDate: searchQuery ? searchQuery.dates.endDate : undefined,
        page: page,
        limit: limit
      },
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'zlick-group': Store.getters.getActiveCognitoGroup
      }
    })
      .catch((error) => {
        Bugsnag.send(error)
        throw new Error('Failed to query subscriptions ' + error)
      })
  },

  update: ({ subscriptionId, ...params }) => {
    if (!AuthenticationService.isInRole(['admin', 'support'])) throw new Error('Permission denied. Cannot update subscription')
    return axios.put(url + '/subscriptions/' + subscriptionId, { ...params }, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'zlick-group': Store.getters.getActiveCognitoGroup
      }
    })
      .catch((error) => {
        Bugsnag.send(error)
        throw error
      })
  },
  createManualSubscription: (params) => {
    if (!AuthenticationService.isInRole(['manual_subs'])) throw new Error('Permission denied. Cannot create the subscription')
    return axios({
      method: 'POST',
      url: url + '/addSubscriber',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'zlick-group': Store.getters.getActiveCognitoGroup
      },
      data: {
        ...params
      }
    })
  },
  createSubscription: ({ productName, userId }) => {
    if (!AuthenticationService.isInRole(['admin', 'telemarketing'])) throw new Error('Permission denied. Cannot create the subscription')
    return axios({
      method: 'POST',
      url: url + '/subscribe',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'zlick-group': Store.getters.getActiveCognitoGroup
      },
      data: {
        productName,
        userId
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/SubscriptionsService.js